<template>
	<div class="loading_animation">
		<lottie
			:options="defaultOptions"
			:width="180"
			v-on:animCreated="handleAnimation"
		/>
	</div>
</template>

<script>
import Lottie from 'vue-lottie';
import * as animationData from '../../images/duco_reveal_lottie_slower.json';

export default {
	data() {
		return {
			defaultOptions: { animationData: animationData, loop: false },
			animationSpeed: 1,
		};
	},

	props: {
		label: {
			default: 'Loading results ...',
		},
	},

	computed: {},

	watch: {},

	methods: {
		handleAnimation: function (anim) {
			this.anim = anim;
		},

		stop: function () {
			this.anim.stop();
		},

		play: function () {
			this.anim.play();
		},

		pause: function () {
			this.anim.pause();
		},

		onSpeedChange: function () {
			this.anim.setSpeed(this.animationSpeed);
		},
	},

	components: {
		lottie: Lottie,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.loading_animation {
	h4 {
		margin: var(--gutter-tablet-desktop) auto 0;
		text-align: center;
		display: block;
		color: black;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/LoadingAnimation.vue